import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import _ from "lodash";

import AppWizard from "../../../shared/appWizard/appWizard";
import SuccessBox from "../../../shared/successBox/successBox";
import ConsulCreation from "./consulCreation";

import { integrationIcons } from "../../../utils/icons";

import { createConsulIntegration } from "../../../redux/actions/consulIntegrationAction";

import "./consulIntegration.scss";

const ConsulIntegration = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [wizardState, setWizardState] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const configWizard = [
    {
      step_title: "Setup",
      step_description: "Consul integration details",
      content_title: "HashiCorp Consul integration",
      content: (
        <ConsulCreation
          wizardState={wizardState}
          setWizardState={setWizardState}
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
      beforeNextStep: async () => {
        setLoadingSubmit(true);
        const created = await dispatch(
          createConsulIntegration(
            wizardState.name,
            wizardState.token,
            wizardState.publicClusterAddress
          )
        );
        setLoadingSubmit(false);
        if (_.isEmpty(created)) {
          throw new Error(
            `Failed to create Consul integration.`
          );
        }
      },
    },
    {
      step_title: "Completion",
      step_description: "",
      content_title: "Integration Created!",
      content: (
        <SuccessBox
          setSubmitDisabled={setSubmitDisabled}
        />
      ),
      valid: true,
    },
  ];

  return (
    <div className="ConsulIntegration">
      <AppWizard
        iconSrc={integrationIcons["consul"]}
        loadingSubmit={loadingSubmit}
        configWizard={configWizard}
        handleClose={() => history.goBack()}
        submitDisabled={submitDisabled}
        setSubmitDisabled={setSubmitDisabled}
        handleSubmit={() => history.push("/integrations")}
      />
    </div>
  );
};

export default ConsulIntegration;
